import i18n from "i18next";
import type { FC } from "react";

import type { FormFieldFactoryProps, FormFieldWrapperProps } from "../../types/types";
import { FormFieldInputStyle, FormFieldLabelStyle, HorizontalFormFieldStyle } from "../styles/FormFieldsStyle";

interface HorizontalFormFieldWrapperProps {
    field?: FormFieldFactoryProps;
    formComponent: React.JSX.Element;
}

export const HorizontalFormFieldWrapper: FC<HorizontalFormFieldWrapperProps> = ({ field, formComponent }: FormFieldWrapperProps) => {
    const shouldHideFormField = field?.component === "HiddenCheckbox" || field?.component === "HiddenValue"; // hiddenLabel applies styling rules: "display: none;"
    const shouldHideLabel = field?.component === "FileContents" || shouldHideFormField;

    return (
        (field?.translationKeys && (
            <HorizontalFormFieldStyle hiddenLabel={shouldHideFormField}>
                <FormFieldLabelStyle>{!shouldHideLabel ? i18n.t(field.translationKeys.label) : ""}</FormFieldLabelStyle>
                <FormFieldInputStyle>{formComponent}</FormFieldInputStyle>
            </HorizontalFormFieldStyle>
        )) || (
            <HorizontalFormFieldStyle hiddenLabel={shouldHideFormField}>
                <FormFieldInputStyle>{formComponent}</FormFieldInputStyle>
            </HorizontalFormFieldStyle>
        )
    );
};
